import { FULFILLMENT } from '../../constants';
import translate from '../../hooks/useTranslation';
import { ACTION_TYPES } from '../../constants/actions';
import {
  ACTION_TYPES as MODULE_ACTION_TYPES,
  FULFILMENT_OPTIONS
} from '@detox/actions';
import { ESHOP_FULFILMENT_OPTION } from '../../constants/fulfillment';
import { isCurrentFulfilmentOption } from '../../components/Fulfilment/helpers';
import { buildGaErrorMeta } from '../../helpers/dataLayerHelpers';
const REQUEST_STATUS = FULFILLMENT.REQUEST_STATUS;

const initialState = {
  postcode: '',
  status: REQUEST_STATUS.IDLE,
  timeSlotsStatus: REQUEST_STATUS.IDLE,
  data: [],
  timeslots: [],
  hasError: false,
  _gaErrorMeta: '',
  errorCode: undefined,
  selectedPopstation: undefined,
  timeSlots: []
};

export default (state = initialState, actions) => {
  const { t } = translate();
  switch (actions.type) {
    case MODULE_ACTION_TYPES.FULFILMENT.ESHOP_GET_FULFILMENT_OUTLET_LOADING:
    case 'GET_POPSTATIONS_LOADING': {
      const fulfilmentType = actions.meta?.fulfilmentOption;
      if (fulfilmentType && fulfilmentType !== FULFILMENT_OPTIONS.POP_STATION) {
        return state;
      }
      return {
        ...state,
        status: REQUEST_STATUS.PENDING,
        data: [],
        selectedPopstation: undefined
      };
    }
    case 'UPDATE_GET_POPSTATIONS_STATUS': {
      return {
        ...state,
        status: actions.payload
      };
    }
    case MODULE_ACTION_TYPES.FULFILMENT.ESHOP_GET_FULFILMENT_OUTLET_SUCCESS:
    case 'GET_POPSTATIONS_SUCCESS': {
      const fulfilmentType = actions?.meta?.fulfilmentOption;
      let popStations = actions?.payload?.implPOPStationDetails;
      if (fulfilmentType) {
        if (fulfilmentType !== FULFILMENT_OPTIONS.POP_STATION) {
          return state;
        } else {
          popStations = actions.payload;
        }
      }

      if (popStations?.length) {
        return {
          ...state,
          data: popStations || [],
          status: REQUEST_STATUS.SUCCEEDED,
          postcode: actions?.meta?.postcode,
          hasError: false,
          errorCode: undefined
        };
      }
      return {
        ...state,
        data: [],
        hasError: true,
        status: REQUEST_STATUS.SUCCEEDED,
        postcode: actions?.meta?.postcode,
        redirectNeeded: false,
        errorCode: 'EMPTY_POPSTATIONS',
        _gaErrorMeta: buildGaErrorMeta({
          isBlocker: false,
          errorType: 'popup',
          featureName: 'popstations',
          errorReason: 'noPopstationsFound',
          errorName: 'No pop stations available for this address'
        })
      };
    }
    case MODULE_ACTION_TYPES.FULFILMENT.ESHOP_GET_FULFILMENT_OUTLET_FAILED:
    case 'GET_POPSTATIONS_FAILED': {
      const fulfilmentType = actions?.meta?.fulfilmentOption;
      if (fulfilmentType && fulfilmentType !== FULFILMENT_OPTIONS.POP_STATION) {
        return state;
      }
      return {
        ...state,
        hasError: true,
        status: REQUEST_STATUS.FAILED,
        data: [],
        _gaErrorMeta: buildGaErrorMeta({
          isBlocker: false,
          errorType: 'popup',
          featureName: 'popstations',
          errorReason: 'fetchPopstationsFailed',
          errorName: 'Unable to fetch pop stations'
        })
      };
    }

    case 'REMOVE_GET_POPSTATION_ERROR': {
      return {
        ...state,
        hasError: undefined,
        errorCode: undefined,
        status:
          state.status === REQUEST_STATUS.PENDING
            ? REQUEST_STATUS.IDLE
            : state.status
      };
    }
    case 'SELECT_POPSTATION': {
      return {
        ...state,
        selectedPopstation: actions.payload
      };
    }
    case 'SET_DELIVERY_MODE': {
      return {
        ...state,
        hasError: undefined,
        errorCode: undefined,
        status:
          state.status === REQUEST_STATUS.PENDING
            ? REQUEST_STATUS.IDLE
            : state.status,
        postcode: '',
        selectedPopstation: undefined,
        data: []
      };
    }
    case 'RESET_POPSTATION': {
      return {
        ...state,
        postcode: '',
        selectedPopstation: undefined,
        data: [],
        hasError: false,
        _gaErrorMeta: ''
      };
    }
    case MODULE_ACTION_TYPES.FULFILMENT.ESHOP_TIME_SLOT_LOADING:
    case 'GET_SELF_COLLECTION_LOADING': {
      if (
        !isCurrentFulfilmentOption(actions.meta, [
          FULFILMENT_OPTIONS.POP_STATION
        ])
      ) {
        return state;
      }
      return {
        ...state,
        hasError: false,
        timeSlotsStatus: REQUEST_STATUS.PENDING,
        status: REQUEST_STATUS.PENDING,
        timeslots: []
      };
    }
    case MODULE_ACTION_TYPES.FULFILMENT.ESHOP_TIME_SLOT_SUCCESS:
    case 'GET_SELF_COLLECTION_SUCCESS': {
      if (
        !isCurrentFulfilmentOption(actions.meta, [
          FULFILMENT_OPTIONS.POP_STATION
        ])
      ) {
        return state;
      }
      const fulfilmentOption = actions?.meta?.fulfilmentOption;
      const isPopStationTimeSlot =
        fulfilmentOption === ESHOP_FULFILMENT_OPTION.POPSTATION;
      if (fulfilmentOption && !isPopStationTimeSlot) {
        return state;
      }

      const slots = isPopStationTimeSlot
        ? actions.payload.slots
        : actions.payload;
      if (!slots?.length) {
        return {
          ...state,
          errorTitle: t('TIME_SLOTS_UNAVAILABLE'),
          errorMessage: t('TIME_SLOTS_UNAVAILABLE_MSG_POPSTATION'),
          timeSlots: [],
          useErrorFromState: true,
          redirectNeeded: false,
          hasError: true,
          isError: true,
          timeSlotsStatus: REQUEST_STATUS.FAILED,
          status: REQUEST_STATUS.FAILED,
          _gaErrorMeta: buildGaErrorMeta({
            isBlocker: false,
            errorType: 'popup',
            featureName: 'popstations',
            errorReason: 'popstationTimeSlotUnavailable',
            errorName: 'No pop station time slots available'
          })
        };
      }
      return {
        ...state,
        hasError: false,
        timeSlotsStatus: REQUEST_STATUS.SUCCEEDED,
        status: REQUEST_STATUS.SUCCEEDED,
        timeSlots: slots || []
      };
    }
    case MODULE_ACTION_TYPES.FULFILMENT.ESHOP_TIME_SLOT_FAILED:
    case 'GET_SELF_COLLECTION_FAILED': {
      if (
        !isCurrentFulfilmentOption(actions.meta, [
          FULFILMENT_OPTIONS.POP_STATION
        ])
      ) {
        return state;
      }

      return {
        ...state,
        hasError: true,
        timeSlotsStatus: REQUEST_STATUS.FAILED,
        status: REQUEST_STATUS.FAILED,
        timeSlots: [],
        redirectNeeded: false,
        errorTitle: t('TIME_SLOTS_UNAVAILABLE'),
        errorMessage: t('TIME_SLOTS_UNAVAILABLE_MSG_POPSTATION'),
        useErrorFromState: true,
        _gaErrorMeta: buildGaErrorMeta({
          isBlocker: false,
          errorType: 'popup',
          featureName: 'popstations',
          errorReason: 'popstationTimeSlotFetchFailed',
          errorName: 'Unable to fetch pop station time slots'
        })
      };
    }
    case ACTION_TYPES.DELIVERY.RESET_ERROR: {
      return {
        ...state,
        hasError: false,
        _gaErrorMeta: ''
      };
    }
    default: {
      return state;
    }
  }
};

export const resetPopStationData = () => dispatch => {
  dispatch({
    type: 'RESET_POPSTATION'
  });
};
